import type { Env } from "@fluentry/domain";

export const devDefaults: Partial<Env> = {
  NODE_ENV: "development",
  LOG_LEVEL: "debug",
  SPEECH_PROVIDER: "google",
  DB_URL: "file:local.db",
};
